// @core/api/endpoints/notifications/send_notification.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  SendNotificationRequest,
  SendNotificationResponse,
} from '../../../types/notifications';

const BASE_PATH = '/notifications';

/**
 * Send a notification
 * Sends a notification to the specified recipient through configured channels. The notification will be delivered based on user preferences and channel availability.
 */
export async function SendNotification(
  data: SendNotificationRequest,
  options?: RequestOptions
): Promise<SendNotificationResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/notifications`;
  const requestOptions = options;
  return client.post<SendNotificationResponse>(requestPath, data, requestOptions);
}
